'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

exports.isObjectLike = isObjectLike;
